import React from 'react';

const NewsList = ({ news, onEdit, onDelete }) => {
  if (!Array.isArray(news) || news.length === 0) {
     return (
        <div className="empty-state">
            <p>📰 Новостей пока нет</p>
            <p className="empty-hint">Нажмите "Создать новость" чтобы добавить первую новость</p>
        </div>
     );
  }

  return (
    <div className="items-list">
      {news.map(item => (
        <div key={item.id} className="item-card">
          {item.cover_image && (
            <img src={item.cover_image} alt={item.title} className="item-image" />
          )}
          <div className="item-content">
            <h3>{item.title}</h3>
            <p className="item-summary">{item.summary}</p>
            <div className="item-meta">
              <span className={`badge badge-${item.status}`}>{item.status}</span>
              {item.is_featured && <span className="badge badge-featured">Важная</span>}
              {item.is_breaking && <span className="badge badge-breaking">Срочная</span>}
              <span className="meta-text">👁 {item.views_count} | ❤️ {item.likes_count} | 💬 {item.comments_count}</span>
            </div>
          </div>
          <div className="item-actions">
            <button className="btn-edit" onClick={() => onEdit(item)}>✏️ Изменить</button>
            <button className="btn-delete" onClick={() => onDelete(item.slug)}>🗑️ Удалить</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NewsList;
